import { useCurrentUser } from '../../contexts/UserContext';
import { useContentTechDomains } from './useContentTechDomains';

/**
 * Whether the current user may perform bar raiser actions on the loaded content.
 * True for Admins on any content, or when the Bar raiser hat is active and the
 * user holds a BarRaiser content role scoped to this content's tech domain —
 * a Databases bar raiser cannot act on Serverless content. Returns false while
 * no document is loaded.
 */
export function useCanActAsBarRaiser(): boolean {
  const { canActAsBarRaiserForContent } = useCurrentUser();
  const { mainTechDomain, techDomains } = useContentTechDomains();

  return canActAsBarRaiserForContent(mainTechDomain, techDomains);
}
